import { type ResultListItem } from '@/_components';
import { MessageTagType } from '@/_types/messages';

export const MESSAGE_TAGS: Record<MessageTagType, string> = {
  general: 'General',
  urgent: 'Urgent',
  emergency: 'Emergency',
};

export const MESSAGE_TAG_OPTIONS: Array<ResultListItem> = Object.keys(
  MESSAGE_TAGS,
).map((tag) => ({
  name: MESSAGE_TAGS[tag as MessageTagType],
  value: tag,
}));
